import React from 'react';

function Footer()
{
   return(
    <div className="text-center misc-footer text-white">
        <p>Copyright &copy; { new Date().getFullYear() } Just a Date</p>
    </div>
   );
}
export default React.memo(Footer)
